
import React from 'react';
import PlansManagement from '@/components/admin/PlansManagement';

const AdminPlansPage = () => {
  
  return <PlansManagement />;
};

export default AdminPlansPage;
